import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";

Vue.use(Vuex);
const modulesFiles = require.context("./modules", true, /\.js$/);
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, "$1");
  const value = modulesFiles(modulePath);
  modules[moduleName] = value.default;
  return modules;
}, {});
const store = new Vuex.Store({ modules, getters });
export default store;

// 
// vuex中的store分模块管理，需要在store的index.js中引入各个模块，为了解
// 决不同模块命名冲突的问题，将不同模块的namespaced:true，之
// 后在不同页面中引入getter、actions、mutations时，需要加上所属的模块名